exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#thongtindcumodem .ui-chkbox-label, #thongtindcumodem .ui-radiobutton-label {\n  margin-bottom: 0px; }\n\n#thongtindcumodem .input-ttct {\n  width: 120px;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #3e515b;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #c2cfd6;\n  border-radius: 0;\n  display: inline-block; }\n\n#thongtindcumodem input[disabled] {\n  background-color: #c2cfd6;\n  opacity: 1 !important;\n  color: #3e515b;\n  border: 1px solid #c2cfd6; }\n\n#thongtindcumodem .ui-dialog {\n  left: 30% !important; }\n\n#thongtindcumodem label {\n  white-space: nowrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-dcu/thongtindcu.component.scss
// module id = ../../../../../src/app/views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-dcu/thongtindcu.component.scss
// module chunks = main